module.exports = __webpack_public_path__ + "img/enfj.ca574646.png";